<template>
    <div class="main-body">
        <div class="header">机构菜品</div>
        <div class="out">

            <div class="search2">

              <el-button size="mini" type="primary" @click.native="toggleModalAdd">添加</el-button>

              <div style="float:right">
                <el-select v-model="institutionCode" placeholder="请选择机构" style="margin-right: 5px;">
                  <el-option
                      v-for="item in arr_ins"
                      :key="item.institutionCode"
                      :label="item.userName"
                      :value="item.institutionCode">
                  </el-option>
                </el-select>
                <el-button size="mini" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
              </div>
              <div style="clear: both;"></div>
            </div>

            <el-table class="table" size="mini" :data="tableData" v-loading="loading"
                      highlight-current-row :height="th" border>

                <el-table-column prop="name" label="名称"></el-table-column>

                <el-table-column prop="status" label="状态">
                  <template slot-scope="scope">
                    <span v-if="scope.row.status == 1">正常</span>
                    <span v-if="scope.row.status == 2">禁用</span>
                  </template>
                </el-table-column>
              <el-table-column fixed="right" label="操作" width="100">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" @click="toggleModalEdit(scope.row)">编辑</el-button>
                </template>
              </el-table-column>

            </el-table>

            <div class="page">
                <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                <div style="float: left;">
                    <el-pagination small
                            background
                            layout="prev, pager, next"
                            :total="totalItems"
                            :page-size="20"
                            @current-change="current_change">
                    </el-pagination>
                </div>
                <div style="clear: both;"></div>
            </div>

        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-bind:arr_ins="arr_ins" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-bind:arr_ins="arr_ins" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>

    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    import Edit from "./EditIns";
    import Add from "./AddIns";

    export default {
        name: "Role",
        data(){
            return{
                loading:false,


                showModalAdd:false,
                showModalEdit:false,

                tableData:[],
                totalItems: 0,
                pageSize:20,
                currentPage:1,

                th:0,

                status:-1,
                statusValue:[{name:'全部状态',value:-1},{name:'正常',value:1},{name:'禁用',value:2}],

              arr_ins:[],
              institutionCode: '',

            }
        },
        components:{
            Add,Edit
        },
        created(){
            this.getIns();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
        },
        methods:{

          getIns(){

            this.$axios({
              method: 'post',
              url: this.$shopUrl+"Institution/ListType",
              data: {
                timeStr: timeStr,
                sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                staffCode: getStaffCode(),
                type:1,
              }
            }).then((response) => {

              if (response.data.error === 0) {
                this.arr_ins = response.data.data.list;
                if(this.arr_ins.length>0){
                  this.institutionCode = this.arr_ins[0].institutionCode;
                  this.getList();
                }
              }else if(response.data.error === 1){
                this.$message.error(response.data.message)
              }

            })

          },


            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },

            toggleModalEdit:function(row){
                this.$refs.myEdit.init(row);
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            getList(){
                this.loading = true;
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Dishes/GovPageIns",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                      institutionCode:this.institutionCode,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    this.loading = false;

                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },


        }
    }
</script>

<style lang='scss' scoped>

</style>
